import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import Navbar from "../../../components/Navbar";
import Background from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import style from "./Cadastramento.module.css";
import { useNavigate } from "react-router-dom";
import modal from "./Modal.module.css";
import MaskedInput from "../../../components/InputMask"; // Importe o MaskedInput
import { SnackbarProvider, useSnackbar } from "notistack";

const Cadastramento = () => {
  const navigate = useNavigate();
  const [selectedTable, setSelectedTable] = useState(""); // Captura a tabela selecionada
  const [formData, setFormData] = useState({}); // Armazena os dados do formulário
  const [erro, setErro] = useState("");
  const [tableData, setTableData] = useState([]); // Armazena os dados da tabela
  const [modalData, setModalData] = useState(null); // Estado para armazenar o usuário selecionado e controlar o modal
  const modalContentRef = useRef(null); // Cria um ref para o conteúdo do modal
  const { enqueueSnackbar } = useSnackbar();
  const [naviosOperacao, setNaviosOperacao] = useState([]);
  const [showPoraoTable, setShowPoraoTable] = useState(false); // Estado para controlar exibição da tabela
  const [numeroPoroes, setNumeroPoroes] = useState(0);
  const [poraoDescarregado, setPoraoDescarregado] = useState([]);
  const [selectedNavio, setSelectedNavio] = useState(""); // Adiciona estado para armazenar o navio selecionado
  const [poraoData, setPoraoData] = useState([]); // Inicializa como um array vazio
  const [selectedPoraoData, setSelectedPoraoData] = useState(null); // Armazena os dados do porão selecionado para edição
  const [produtos, setProdutos] = useState([]); // Estado para armazenar os produtos

  // Função para formatar CNPJ
  const formatCNPJ = (cnpj) => {
    return cnpj
      .replace(/\D/g, "") // Remove todos os caracteres não numéricos
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .substring(0, 18); // Limita o CNPJ a 18 caracteres
  };

  // Função para formatar CPF
  const formatCPF = (cpf) => {
    return cpf
      .replace(/\D/g, "") // Remove todos os caracteres não numéricos
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
      .substring(0, 14); // Limita o CPF a 14 caracteres
  };

  // Função para formatar a data
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  };

  // Função para lidar com mudanças nos campos de entrada
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      // Armazena o valor sem máscara para o CPF ou CNPJ no estado formData
      [name]:
        name === "CNPJ_CLIENTE" || name === "CPF"
          ? value.replace(/\D/g, "")
          : value || "",
      // Exibe o valor formatado para o CNPJ ou CPF apenas visualmente
      CNPJ_CLIENTE_masked:
        name === "CNPJ_CLIENTE"
          ? formatCNPJ(value)
          : prevData.CNPJ_CLIENTE_masked,
      CPF_masked: name === "CPF" ? formatCPF(value) : prevData.CPF_masked,
    }));
  };

  // Função para lidar com a seleção da tabela
  const handleTableSelect = (e) => {
    setSelectedTable(e.target.value);
    setFormData({});
    setShowPoraoTable(false); // Reseta a exibição da tabela quando uma nova tabela é selecionada

    // Carrega a lista de navios em operação apenas para a tabela 'PORAO', mas não chama fetchPoraoData
    if (e.target.value === "PORAO") {
      fetchNaviosOperacao();
    }
  };

  // Função para buscar dados da tabela PORAO quando COD_NAVIO é selecionado
  const fetchPoraoData = (codOperacao) => {
    Axios.get(`https://operacao.setlogistica.com.br/api/porao/${codOperacao}`)
      .then((response) => {
        setTableData(response.data); // Atualiza os dados da tabela
        setErro("");
        setShowPoraoTable(response.data.length > 0); // Exibe a tabela apenas se houver dados
      })
      .catch((error) => {
        console.error("Erro ao buscar dados da tabela PORAO", error);
        setTableData([]); // Limpa os dados em caso de erro
        setShowPoraoTable(false); // Esconde a tabela em caso de erro
      });
  };

  const handleNavioSelect = async (e) => {
    const selectedNavio = e.target.value;
    setFormData({ ...formData, COD_NAVIO: selectedNavio });

    if (selectedNavio) {
      await fetchPoraoData(selectedNavio);
      await getCargoHolds(selectedNavio); // Fetch cargo holds when navio is selected
      await getPoraoData(selectedNavio); // Chama a nova função para buscar os dados do porão
      setShowPoraoTable(true);
      setSelectedNavio(selectedNavio); // Atualiza o estado com o navio selecionado
    } else {
      setShowPoraoTable(false);
    }
  };

  const getCargoHolds = async (codOperacao) => {
    try {
      const response = await Axios.get(
        `https://operacao.setlogistica.com.br/api/operacao/${codOperacao}/cargo-holds`
      );
      if (response.status === 200) {
        const { CARGO_HOLDS, NOME_NAVIO } = response.data;
        setNumeroPoroes(CARGO_HOLDS);
        setSelectedNavio(NOME_NAVIO);
      } else {
        showAlert("Erro ao carregar informações do navio.", "error");
      }
    } catch (error) {
      showAlert("Erro ao carregar informações do navio.", "error");
      console.error(error);
    }
  };

  // Função para enviar os dados do formulário para inserção no banco de dados
  const handleSubmit = () => {
    if (selectedTable === "PORAO") {
      // Não envia dados para o endpoint quando a tabela selecionada é 'PORAO'
      return;
    }

    if (selectedTable === "USUARIO") {
      // Código para enviar dados para a tabela USUARIO
      const formattedCPF = formData.CPF.replace(/\D/g, "");
      const userExists = tableData.some(
        (row) => row.USUARIO === formData.USUARIO
      );
      const cpfExists = tableData.some(
        (row) => row.CPF.replace(/\D/g, "") === formattedCPF
      );

      if (userExists) {
        showAlert("Já existe um usuário registrado com este nome.", "error");
        return;
      }

      if (cpfExists) {
        showAlert("Já existe um usuário registrado com este CPF.", "error");
        return;
      }

      if (
        (formData.USUARIO && formData.USUARIO.includes("@")) ||
        (formData.NOME && formData.NOME.includes("@"))
      ) {
        showAlert(
          'Os campos "Usuário" e "Nome" não podem conter o caractere "@".',
          "error"
        );
        return;
      }

      const dataToSubmit = {
        ...formData,
        CPF: formattedCPF,
      };

      Axios.post(
        `https://operacao.setlogistica.com.br/api/administrador/${selectedTable.toLowerCase()}`,
        dataToSubmit
      )
        .then((response) => {
          showAlert("Dados inseridos com sucesso!", "success");
          fetchTableData();
        })
        .catch((error) => {
          console.error("Erro ao inserir dados", error);
          showAlert(
            "Erro ao inserir dados. Verifique as informações e tente novamente.",
            "error"
          );
        });
    } else if (selectedTable === "CLIENTE") {
      // Código para enviar dados para a tabela CLIENTE
      const formattedCNPJ = formData.CNPJ_CLIENTE.replace(/\D/g, "");
      const cnpjExists = tableData.some(
        (row) => row.CNPJ_CLIENTE.replace(/\D/g, "") === formattedCNPJ
      );

      if (cnpjExists) {
        showAlert("Já existe um cliente registrado com este CNPJ.", "error");
        return;
      }

      const dataToSubmit = {
        ...formData,
        CNPJ_CLIENTE: formattedCNPJ,
      };

      Axios.post(
        `https://operacao.setlogistica.com.br/api/administrador/${selectedTable.toLowerCase()}`,
        dataToSubmit
      )
        .then((response) => {
          showAlert("Dados inseridos com sucesso!", "success");
          fetchTableData();
        })
        .catch((error) => {
          console.error("Erro ao inserir dados", error);
          showAlert(
            "Erro ao inserir dados. Verifique as informações e tente novamente.",
            "error"
          );
        });
    } else {
      // Código para outras tabelas
      const dataToSubmit = {
        ...formData,
        CPF: formData.CPF && formData.CPF.replace(/\D/g, ""),
      };

      Axios.post(
        `https://operacao.setlogistica.com.br/api/administrador/${selectedTable.toLowerCase()}`,
        dataToSubmit
      )
        .then((response) => {
          showAlert("Dados inseridos com sucesso!", "success");
          fetchTableData();
        })
        .catch((error) => {
          console.error("Erro ao inserir dados", error);
          showAlert(
            "Erro ao inserir dados. Verifique as informações e tente novamente.",
            "error"
          );
        });
    }
  };

  // Função para buscar os dados da tabela selecionada
  const fetchTableData = () => {
    if (selectedTable && selectedTable !== "PORAO") {
      // Adiciona verificação para ignorar PORAO
      Axios.get(
        `https://operacao.setlogistica.com.br/api/administrador/${selectedTable.toLowerCase()}`
      )
        .then((response) => {
          setTableData(response.data); // Armazena os dados da tabela
          setErro("");
        })
        .catch((error) => {
          console.error("Erro ao buscar dados da tabela", error);
          setTableData([]); // Limpa os dados caso haja erro
        });
    }
  };

  // Chame `fetchTableData` no useEffect para buscar os dados inicialmente
  useEffect(() => {
    if (selectedTable && selectedTable !== "PORAO") {
      // Adiciona verificação para ignorar PORAO
      fetchTableData();
    }
  }, [selectedTable]);

  // useEffect para buscar os dados da tabela selecionada ao mudar a seleção
  useEffect(() => {
    if (selectedTable && selectedTable !== "PORAO") {
      // Exclui a execução quando selectedTable for "PORAO"
      // Faz a requisição para buscar todos os dados da tabela selecionada
      Axios.get(
        `https://operacao.setlogistica.com.br/api/administrador/${selectedTable.toLowerCase()}`
      )
        .then((response) => {
          setTableData(response.data); // Armazena os dados da tabela
          setErro("");
        })
        .catch((error) => {
          console.error("Erro ao buscar dados da tabela", error);
          setErro("Erro ao buscar dados da tabela. Tente novamente.");
          setTableData([]); // Limpa os dados caso haja erro
        });
    }
  }, [selectedTable]);

  // Adiciona o event listener para o clique fora do modal
  useEffect(() => {
    if (modalData) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [modalData]);

  const closeModal = () => {
    setModalData(null); // Para o modal principal
    setSelectedPoraoData(null); // Para o modal de edição do porão
  };

  const handleOutsideClick = (e) => {
    // Verifica se o clique foi fora do conteúdo do modal
    if (
      modalContentRef.current &&
      !modalContentRef.current.contains(e.target)
    ) {
      closeModal(); // Chama a função para fechar o modal
    }
  };

  useEffect(() => {
    if (selectedPoraoData) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [selectedPoraoData]);

  const handlePermissionChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      permissions: {
        ...prevData.permissions,
        [value]: checked,
      },
    }));
  };

  const handleSavePermissions = () => {
    if (!formData.USUARIO) {
      setErro("Usuário não definido. Verifique os dados e tente novamente.");
      return;
    }

    // Converte as permissões em um array de objetos { permission, enabled }
    const permissionsArray = Object.keys(formData.permissions).map((key) => ({
      permission: key,
      enabled: formData.permissions[key],
    }));

    Axios.post(
      `https://operacao.setlogistica.com.br/api/administrador/usuario/permissoes`,
      {
        usuario: formData.USUARIO,
        permissions: permissionsArray,
      }
    )
      .then((response) => {
        showAlert("Permissões salvas com sucesso!", "success");
        closeModal();
      })
      .catch((error) => {
        console.error("Erro ao salvar permissões:", error);
        setErro("Erro ao salvar permissões. Tente novamente.");
      });
  };

  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant });
  };

  const handleSaveEmail = () => {
    if (!formData.COD_CLIENTE) {
      setErro("Cliente não definido. Verifique os dados e tente novamente.");
      return;
    }

    Axios.put(
      `https://operacao.setlogistica.com.br/api/cliente/${formData.COD_CLIENTE}`,
      {
        EMAILS: formData.EMAILS,
      }
    )
      .then((response) => {
        showAlert("Email atualizado com sucesso!", "success");
        fetchTableData(); // Atualiza a tabela após a edição
        closeModal();
      })
      .catch((error) => {
        console.error("Erro ao atualizar email:", error);
        setErro("Erro ao atualizar email. Tente novamente.");
      });
  };

  const openModal = (row) => {
    setModalData(row);
    setFormData({
      ...row,
      EMAILS: row.EMAILS || "",
      PRODUTO: row.PRODUTO || "",
      NCM: row.NCM || "",
      IND_CARGA_IMO: row.IND_CARGA_IMO || "",
    });

    console.log("COD_PRODUTO capturado no openModal:", row.COD_PRODUTO); // Verifica o COD_PRODUTO

    if (selectedTable === "USUARIO") {
      Axios.get(
        `https://operacao.setlogistica.com.br/api/administrador/usuario/permissoes/${row.USUARIO}`
      )
        .then((response) => {
          const permissions = response.data.reduce((acc, perm) => {
            acc[perm.NAV_BAR] = true;
            return acc;
          }, {});
          setFormData((prevData) => ({
            ...prevData,
            permissions,
          }));
        })
        .catch((error) => {
          console.error("Erro ao carregar permissões:", error);
          setErro("Erro ao carregar permissões. Tente novamente.");
        });
    }
  };

  const handleSaveProduct = () => {
    if (!formData.COD_PRODUTO) {
      setErro("Produto não definido. Verifique os dados e tente novamente.");
      console.log("Erro: COD_PRODUTO não está definido em handleSaveProduct.");
      return;
    }

    console.log(
      "Enviando COD_PRODUTO em handleSaveProduct:",
      formData.COD_PRODUTO
    ); // Verifica o COD_PRODUTO antes de enviar

    Axios.put(
      `https://operacao.setlogistica.com.br/api/produto/${formData.COD_PRODUTO}`,
      {
        PRODUTO: formData.PRODUTO,
        NCM: formData.NCM || "", // Opcional
        IND_CARGA_IMO: formData.IND_CARGA_IMO,
        NOME_REDUZIDO_PRODUTO: formData.NOME_REDUZIDO_PRODUTO,
      }
    )
      .then((response) => {
        showAlert("Produto atualizado com sucesso!", "success");
        fetchTableData();
        closeModal();
      })
      .catch((error) => {
        console.error("Erro ao atualizar produto:", error);
        setErro("Erro ao atualizar produto. Tente novamente.");
      });
  };

  const handleSavePorao = () => {
    if (!formData.COD_OPERACAO) {
      setErro("Porão não definido. Verifique os dados e tente novamente.");
      return;
    }

    Axios.put(
      `https://operacao.setlogistica.com.br/api/porao/${formData.COD_OPERACAO}`,
      {
        COD_OPERACAO: formData.COD_OPERACAO,
        COD_PRODUTO_01: formData.COD_PRODUTO_01,
        PORAO_01_MANIFESTADO: formData.PORAO_01_MANIFESTADO,
        PORAO_01_DESCARREGADO: formData.PORAO_01_DESCARREGADO,
        // Envie outros campos conforme necessário
      }
    )
      .then((response) => {
        showAlert("Porão atualizado com sucesso!", "success");
        fetchTableData();
        closeModal();
      })
      .catch((error) => {
        console.error("Erro ao atualizar porão:", error);
        setErro("Erro ao atualizar porão. Tente novamente.");
      });
  };

  const fetchNaviosOperacao = () => {
    Axios.get(
      "https://operacao.setlogistica.com.br/api/administrador/navio/operacao"
    )
      .then((response) => {
        setNaviosOperacao(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar navios em operação:", error);
        setErro("Erro ao buscar navios em operação.");
      });
  };

  const getPoraoData = (codOperacao) => {
    Axios.get(`https://operacao.setlogistica.com.br/api/porao/${codOperacao}`)
      .then((response) => {
        if (response.data) {
          console.log("Dados recebidos do porão:", response.data); // Log dos dados recebidos
          setPoraoData(response.data[0]); // Armazena o primeiro item do array no estado
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar dados do Porão:", error);
      });
  };

  const openEditPoraoModal = (index) => {
    const poraoIndex = index + 1; // Para corresponder ao formato utilizado
    const produto = poraoData[`PRODUTO_0${poraoIndex}`] || "";
    const manifestado = poraoData[`PORAO_0${poraoIndex}_MANIFESTADO`] || "";
    const idPorao = poraoData.ID_PORAO; // Captura o ID_PORAO correspondente

    setSelectedPoraoData({
      index: poraoIndex, // Armazena o índice do porão
      produto,
      manifestado,
      ID_PORAO: idPorao, // Armazena o ID_PORAO
    });
  };

  const handleSaveEditPorao = () => {
    const { index, produto, manifestado } = selectedPoraoData;

    console.log("Atualizando porão com COD_OPERACAO:", formData.COD_NAVIO);

    // Enviar uma requisição PUT para atualizar os dados do porão
    Axios.put(`/api/porao/index/${index}`, {
      COD_OPERACAO: formData.COD_NAVIO, // Passando COD_OPERACAO
      [`COD_PRODUTO_0${index}`]: produto,
      [`PORAO_0${index}_MANIFESTADO`]: manifestado,
    })
      .then((response) => {
        showAlert("Dados do porão atualizados com sucesso!", "success");

        // Fecha o modal
        setSelectedPoraoData(null);

        // Atualiza a tabela após a edição usando o COD_OPERACAO
        return fetchPoraoData(formData.COD_NAVIO); // Use COD_NAVIO do estado
      })
      .catch((error) => {
        console.error("Erro ao atualizar os dados do porão:", error);
        setErro("Erro ao atualizar os dados do porão. Tente novamente.");
      });
  };

  const fetchProdutos = async () => {
    try {
      const response = await Axios.get(
        "https://operacao.setlogistica.com.br/api/produtos"
      ); // Faça a chamada para a API
      setProdutos(response.data); // Armazena os produtos no estado
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      setErro("Erro ao buscar produtos. Tente novamente.");
    }
  };

  // UseEffect para buscar produtos quando o componente é montado
  useEffect(() => {
    fetchProdutos();
  }, []);

  return (
    <>
      <Navbar />
      <Header />
      <Background />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div
              className={style.navItem}
              onClick={() => navigate("/administradorpage/administrador")}
            >
              Cadastramento
            </div>
            <div
              className={style.navItem}
              onClick={() => navigate("/administradorpage/cameras")}
            >
              Câmeras
            </div>
            <div
              className={style.navItem}
              onClick={() =>
                navigate("/administradorpage/relatorioautosaberto")
              }
            >
              Autos Em Aberto
            </div>
            <div className={style.navItemActive}>{">"} Cadastramento</div>
          </div>

          {/* Formulário em 3 colunas */}
          <div className={style.formContainer}>
            <select
              value={selectedTable}
              onChange={handleTableSelect}
              className={style.inputField}
            >
              <option value="">Selecione a Tabela</option>
              <option value="ARMADOR">ARMADOR</option>
              <option value="CLIENTE">CLIENTE</option>
              <option value="PRODUTO">PRODUTO</option>
              <option value="DESTINO">DESTINO</option>
              <option value="TRANSPORTADORA">TRANSPORTADORA</option>
              <option value="USUARIO">USUARIO</option>
              <option value="PORAO">PORAO</option> {/* Nova opção */}
            </select>

            {selectedTable === "ARMADOR" && (
              <>
                <input
                  type="text"
                  placeholder="Nome Armador"
                  name="NOME_ARMADOR"
                  value={formData.NOME_ARMADOR || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="CNPJ Armador"
                  name="CNPJ_ARMADOR"
                  value={formData.CNPJ_ARMADOR || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
              </>
            )}

            {selectedTable === "CLIENTE" && (
              <>
                <input
                  type="text"
                  placeholder="Nome Cliente"
                  name="NOME_CLIENTE"
                  value={formData.NOME_CLIENTE || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="00.000.000/0000-00"
                  name="CNPJ_CLIENTE"
                  value={formData.CNPJ_CLIENTE_masked || ""} // Exibe o CNPJ com máscara visual
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  name="EMAILS"
                  value={formData.EMAILS} // Use apenas formData.EMAILS
                  onChange={handleInputChange} // Permite edição apenas neste campo
                  className={modal.inputField}
                />
                <input
                  type="text"
                  placeholder="Nome Reduzido"
                  name="NOME_REDUZIDO"
                  value={formData.NOME_REDUZIDO || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="number"
                  placeholder="Grupo"
                  name="GRUPO"
                  value={formData.GRUPO || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
              </>
            )}

            {selectedTable === "PRODUTO" && (
              <>
                <input
                  type="text"
                  placeholder="Produto"
                  name="PRODUTO"
                  value={formData.PRODUTO || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="NCM"
                  name="NCM"
                  value={formData.NCM || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <select
                  name="IND_CARGA_IMO"
                  value={formData.IND_CARGA_IMO || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                >
                  <option value="">Produto Perigoso?</option>
                  <option value="S">SIM</option>
                  <option value="N">NÃO</option>
                </select>
                <input
                  type="text"
                  placeholder="Nome Reduzido do Produto"
                  name="NOME_REDUZIDO_PRODUTO"
                  value={formData.NOME_REDUZIDO_PRODUTO || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
              </>
            )}

            {selectedTable === "DESTINO" && (
              <>
                <input
                  type="text"
                  placeholder="DESTINO"
                  name="NOME_DESTINO"
                  value={formData.NOME_DESTINO || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
              </>
            )}

            {selectedTable === "TRANSPORTADORA" && (
              <>
                <input
                  type="text"
                  placeholder="Nome Transportadora"
                  name="NOME_TRANSP"
                  value={formData.NOME_TRANSP || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="Nome Reduzido"
                  name="NOME_REDUZIDO"
                  value={formData.NOME_REDUZIDO || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="CNPJ Transportadora"
                  name="CNPJ_TRANSP"
                  value={formData.CNPJ_TRANSP || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="Endereço"
                  name="ENDERECO"
                  value={formData.ENDERECO || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="CEP"
                  name="CEP"
                  value={formData.CEP || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="Cidade/Estado"
                  name="CIDADE_ESTADO"
                  value={formData.CIDADE_ESTADO || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="Inscrição Estadual"
                  name="INSCRICAO_ESTADUAL"
                  value={formData.INSCRICAO_ESTADUAL || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="ANTT"
                  name="ANTT"
                  value={formData.ANTT || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
              </>
            )}

            {selectedTable === "USUARIO" && (
              <>
                <input
                  type="text"
                  placeholder="Usuário"
                  name="USUARIO"
                  value={formData.USUARIO || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="Nome"
                  name="NOME"
                  value={formData.NOME || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="text"
                  placeholder="000.000.000-00"
                  name="CPF"
                  value={formData.CPF_masked || ""} // Exibe o CPF com máscara visual
                  onChange={handleInputChange}
                  className={style.inputField}
                />

                <input
                  type="email"
                  placeholder="Email"
                  name="EMAIL"
                  value={formData.EMAIL || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <input
                  type="password"
                  placeholder="Senha"
                  name="SENHA"
                  value={formData.SENHA || ""}
                  onChange={handleInputChange}
                  className={style.inputField}
                />
                <div className={style.statusToggle}>
                  <button
                    type="button"
                    onClick={() =>
                      setFormData({
                        ...formData,
                        ATIVO: formData.ATIVO === "S" ? "N" : "S",
                      })
                    }
                    className={style.toggleButton}
                    style={{
                      backgroundColor: formData.ATIVO === "S" ? "green" : "red",
                      color: "white",
                    }}
                  >
                    {formData.ATIVO === "S" ? "Ativo" : "Inativo"}
                  </button>
                </div>
              </>
            )}

            {selectedTable === "PORAO" && (
              <select
                value={formData.COD_NAVIO || ""}
                onChange={handleNavioSelect}
                className={style.inputField}
              >
                <option value="">Selecione o Navio</option>
                {naviosOperacao.length > 0 ? (
                  naviosOperacao.map((navio) => (
                    <option key={navio.COD_NAVIO} value={navio.COD_OPERACAO}>
                      {navio.NOME_NAVIO}
                    </option>
                  ))
                ) : (
                  <option value="">Nenhum navio disponível</option>
                )}
              </select>
            )}

            {/* Botão para cadastrar os dados inseridos */}
            <div className={style.submitButtonContainer}>
              <button onClick={handleSubmit} className={style.submitButton}>
                Cadastrar
              </button>
            </div>
          </div>

          {/* Mensagem de erro */}
          {erro && <p className={style.error}>{erro}</p>}

          {/* Tabela exibindo os dados da tabela selecionada */}
          {selectedTable && (
            <div className={style.tableContainer}>
              <table className={style.table}>
                <thead>
                  <tr>
                    {selectedTable === "ARMADOR" && (
                      <>
                        <th>NOME ARMADOR</th>
                        <th>CNPJ ARMADOR</th>
                      </>
                    )}

                    {selectedTable === "CLIENTE" && (
                      <>
                        <th>NOME_CLIENTE</th>
                        <th>CNPJ</th>
                        <th>E-MAILS</th>
                        <th>NOME FANTASIA</th>
                        <th>GRUPO</th>
                      </>
                    )}
                    {selectedTable === "PRODUTO" && (
                      <>
                        <th>PRODUTO</th>
                        <th>NCM</th>
                        <th>PRODUTO PERIGOSO?</th>
                        <th>NOME REDUZIDO</th>
                      </>
                    )}
                    {selectedTable === "DESTINO" && (
                      <>
                        <th>DESTINO</th>
                     </>
                    )}
                    {selectedTable === "TRANSPORTADORA" && (
                      <>
                        <th>TRANSPORTADORA</th>
                        <th>NOME FANTASIA</th>
                        <th>CNPJ</th>
                        <th>ENDEREÇO</th>
                        <th>CEP</th>
                        <th>CIDADE/ESTADO</th>
                        <th>INSCRIÇÃO ESTADUAL</th>
                        <th>ANTT</th>
                      </>
                    )}
                    {selectedTable === "USUARIO" && (
                      <>
                        <th>USUÁRIO</th>
                        <th>NOME</th>
                        <th>CPF</th>
                        <th>EMAIL</th>
                        <th>SENHA</th>
                        <th>ATIVO</th>
                        <th>DATA DE CADASTRO</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr
                      key={index}
                      onClick={() =>
                        (selectedTable === "USUARIO" ||
                          selectedTable === "CLIENTE" ||
                          selectedTable === "PRODUTO" ||
                          selectedTable === "PORAO") &&
                        openModal(row)
                      } // Abre o modal também para PORAO
                    >
                      {Object.keys(row)
                        .filter(
                          (key) =>
                            !key.startsWith("COD_") && key !== "UN_MEDIDA"
                        ) // Ignora colunas que começam com "COD_" e a coluna "UN_MEDIDA"
                        .map((key, idx) => (
                          <td key={idx}>
                            {key === "DAT_CADASTRO"
                              ? formatDate(row[key])
                              : key === "SENHA"
                              ? "*******" // Exibe asteriscos para a coluna SENHA
                              : key === "CPF"
                              ? formatCPF(row[key]) // Formata CPF com base na função formatCPF
                              : key.includes("CNPJ") && row[key]
                              ? formatCNPJ(row[key])
                              : key === "IND_CARGA_IMO"
                              ? row[key] === "S"
                                ? "SIM"
                                : row[key] === "N"
                                ? "NÃO"
                                : ""
                              : row[key] || ""}
                          </td>
                        ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Modal com os dados do usuário e radio buttons */}
          {modalData && selectedTable === "USUARIO" && (
            <div className={modal.modal} onClick={handleOutsideClick}>
              <div className={modal.modalContent} ref={modalContentRef}>
                <h3>Detalhes do Usuário</h3>

                <div className={modal.formGroup}>
                  <label>Nome:</label>
                  <input
                    type="text"
                    name="NOME"
                    value={formData.NOME || modalData.NOME}
                    onChange={handleInputChange}
                    className={modal.inputField}
                  />
                </div>

                <div className={modal.formGroup}>
                  <label>CPF:</label>
                  <input
                    type="text"
                    placeholder="000.000.000-00"
                    name="CPF"
                    value={formData.CPF || modalData.CPF}
                    onChange={handleInputChange}
                    className={modal.inputField}
                  />
                </div>

                <div className={modal.formGroup}>
                  <label>Email:</label>
                  <input
                    type="email"
                    name="EMAIL"
                    value={formData.EMAIL || modalData.EMAIL}
                    onChange={handleInputChange}
                    className={modal.inputField}
                  />
                </div>

                <h4 className={modal.permissionTitle}>Permissões</h4>
                <div className={modal.radioButtons}>
                  {[
                    "NAVIOS",
                    "DOCUMENTAÇÃO",
                    "SEG TRABALHO",
                    "CUSTEIO",
                    "MANUTENÇÃO",
                    "AUTOS",
                    "OPERAÇÃO",
                    "RELATÓRIOS",
                    "INTEGRAÇÃO",
                    "ADMINISTRADOR",
                    "CLIENTE",
                  ].map((label, index) => (
                    <div key={index} className={modal.checkboxOption}>
                      <input
                        type="checkbox"
                        id={`perm_${label}`}
                        name="permissions"
                        value={label}
                        checked={formData.permissions?.[label] || false}
                        onChange={handlePermissionChange}
                      />
                      <label htmlFor={`perm_${label}`}>{label}</label>
                    </div>
                  ))}
                </div>
                <button
                  className={modal.saveButton}
                  onClick={handleSavePermissions}
                >
                  Salvar
                </button>
              </div>
            </div>
          )}

          {modalData && selectedTable === "PRODUTO" && (
            <div className={modal.modal} onClick={handleOutsideClick}>
              <div className={modal.modalContent} ref={modalContentRef}>
                <h3>Detalhes do Produto</h3>

                <div className={modal.formGroup}>
                  <label>Produto:</label>
                  <input
                    type="text"
                    name="PRODUTO"
                    value={formData.PRODUTO || ""}
                    onChange={handleInputChange}
                    className={modal.inputField}
                  />
                </div>

                <div className={modal.formGroup}>
                  <label>NCM:</label>
                  <input
                    type="text"
                    name="NCM"
                    value={formData.NCM || ""}
                    onChange={handleInputChange}
                    className={modal.inputField}
                  />
                </div>

                <div className={modal.formGroup}>
                  <label>Produto Perigoso?</label>
                  <select
                    name="IND_CARGA_IMO"
                    value={formData.IND_CARGA_IMO || ""}
                    onChange={handleInputChange}
                    className={modal.inputField}
                  >
                    <option value="S">SIM</option>
                    <option value="N">NÃO</option>
                  </select>
                </div>

                <div className={modal.formGroup}>
                  <label>Nome Reduzido:</label>
                  <input
                    type="text"
                    name="NOME_REDUZIDO_PRODUTO"
                    value={formData.NOME_REDUZIDO_PRODUTO || ""}
                    onChange={handleInputChange}
                    className={modal.inputField}
                  />
                </div>

                <button
                  className={modal.saveButton}
                  onClick={handleSaveProduct}
                >
                  Salvar
                </button>
              </div>
            </div>
          )}

          {modalData && selectedTable === "CLIENTE" && (
            <div className={modal.modal} onClick={handleOutsideClick}>
              <div className={modal.modalContent} ref={modalContentRef}>
                <h3>Detalhes do Cliente</h3>

                <div className={modal.formGroup}>
                  <label>Nome do Cliente:</label>
                  <input
                    type="text"
                    name="NOME_CLIENTE"
                    value={formData.NOME_CLIENTE || ""}
                    readOnly
                    className={modal.inputField}
                  />
                </div>

                <div className={modal.formGroup}>
                  <label>CNPJ:</label>
                  <input
                    type="text"
                    placeholder="00.000.000/0000-00"
                    name="CNPJ_CLIENTE"
                    value={formData.CNPJ_CLIENTE || ""}
                    readOnly
                    className={modal.inputField}
                  />
                </div>

                <div className={modal.formGroup}>
                  <label>Email:</label>
                  <input
                    type="text"
                    name="EMAILS"
                    value={formData.EMAILS || ""} // Remove a referência a modalData
                    onChange={handleInputChange} // Permite edição apenas neste campo
                    className={modal.inputField}
                  />
                </div>

                <div className={modal.formGroup}>
                  <label>Grupo:</label>
                  <input
                    type="number"
                    name="GRUPO"
                    value={formData.GRUPO || ""}
                    readOnly
                    className={modal.inputField}
                  />
                </div>

                <button className={modal.saveButton} onClick={handleSaveEmail}>
                  Salvar
                </button>
              </div>
            </div>
          )}

          {modalData && selectedTable === "PORAO" && (
            <div className={modal.modal} onClick={handleOutsideClick}>
              <div className={modal.modalContent} ref={modalContentRef}>
                <h3>Detalhes do Porão</h3>

                <div className={modal.formGroup}>
                  <label>ID PORAO:</label>
                  <input
                    type="text"
                    name="ID_PORAO"
                    value={formData.ID_PORAO || ""}
                    readOnly
                    className={modal.inputField}
                  />
                </div>

                <div className={modal.formGroup}>
                  <label>COD OPERACAO:</label>
                  <input
                    type="text"
                    name="COD_OPERACAO"
                    value={formData.COD_OPERACAO || ""}
                    onChange={handleInputChange}
                    className={modal.inputField}
                  />
                </div>

                <div className={modal.formGroup}>
                  <label>COD PRODUTO 01:</label>
                  <input
                    type="text"
                    name="COD_PRODUTO_01"
                    value={formData.COD_PRODUTO_01 || ""}
                    onChange={handleInputChange}
                    className={modal.inputField}
                  />
                </div>

                {/* Repita para os outros campos da tabela PORAO conforme necessário */}

                <button className={modal.saveButton} onClick={handleSavePorao}>
                  Salvar
                </button>
              </div>
            </div>
          )}

          {erro && <p className={style.error}>{erro}</p>}

          {selectedTable === "PORAO" && showPoraoTable && (
            <div className={modal.tableWrapper}>
              <table className={modal.breakdownTable}>
                <thead>
                  <tr>
                    {[...Array(numeroPoroes)].map((_, index) => (
                      <th key={index}>Porão {index + 1}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {/* Linha de produtos */}
                  <tr>
                    {[...Array(numeroPoroes)].map((_, index) => (
                      <td key={index} onClick={() => openEditPoraoModal(index)}>
                        {poraoData && poraoData[`PRODUTO_0${index + 1}`]
                          ? poraoData[`PRODUTO_0${index + 1}`]
                          : "N/A"}
                      </td>
                    ))}
                  </tr>
                  {/* Linha de manifestado */}
                  <tr>
                    {[...Array(numeroPoroes)].map((_, index) => (
                      <td key={index} onClick={() => openEditPoraoModal(index)}>
                        {poraoData &&
                        poraoData[`PORAO_0${index + 1}_MANIFESTADO`]
                          ? `${(
                              poraoData[`PORAO_0${index + 1}_MANIFESTADO`] /
                              1000
                            ).toLocaleString("pt-BR", {
                              minimumFractionDigits: 3,
                              maximumFractionDigits: 3,
                            })} Tons`
                          : "0,000 Tons"}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {selectedPoraoData && (
            <div className={modal.modal} onClick={handleOutsideClick}>
              <div className={modal.modalContent} ref={modalContentRef}>
                <h3>Editar Porão {selectedPoraoData.index}</h3>

                <div className={modal.formGroup}>
                  <label>Produto:</label>
                  <select
                    name="produto"
                    value={selectedPoraoData.produto} // Aqui deve ser o COD_PRODUTO
                    onChange={(e) =>
                      setSelectedPoraoData({
                        ...selectedPoraoData,
                        produto: e.target.value,
                      })
                    }
                    className={modal.inputField}
                  >
                    <option value="">Selecione um Produto</option>
                    {produtos.map((produto) => (
                      <option
                        key={produto.COD_PRODUTO}
                        value={produto.COD_PRODUTO}
                      >
                        {" "}
                        {/* Use COD_PRODUTO como value */}
                        {produto.PRODUTO} {/* Nome do produto */}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={modal.formGroup}>
                  <label>Manifestado (em Tons):</label>
                  <input
                    type="number"
                    name="manifestado"
                    value={selectedPoraoData.manifestado}
                    onChange={(e) =>
                      setSelectedPoraoData({
                        ...selectedPoraoData,
                        manifestado: e.target.value,
                      })
                    }
                    className={modal.inputField}
                  />
                </div>

                <button
                  className={modal.saveButton}
                  onClick={handleSaveEditPorao}
                >
                  Salvar
                </button>
              </div>
            </div>
          )}
        </div>
      </Container>
    </>
  );
};

// Envolvendo Cadastramento com SnackbarProvider
export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <Cadastramento />
    </SnackbarProvider>
  );
}
